// Значения приходят из /env.js: в контейнере его пишет config/docker-entrypoint.sh,
// локально это копия env.example.js в public/.

export const ENV_KEYS = [
  'APP_ENV',
  'KEYCLOAK_URL',
  'KEYCLOAK_REALM',
  'KEYCLOAK_CLIENT_ID',
  'SENTRY_DSN',
  'SENTRY_TRACES_SAMPLE_RATE',
  'YANDEX_METRIKA_ID',
  'FIREBASE_API_KEY',
  'FIREBASE_AUTH_DOMAIN',
  'FIREBASE_DATABASE_URL',
  'FIREBASE_PROJECT_ID',
  'FIREBASE_STORAGE_BUCKET',
  'FIREBASE_MESSAGING_SENDER_ID',
  'FIREBASE_APP_ID',
  'FIREBASE_VAPID_KEY',
  'AI_WIDGET_URL',
  'SERVICE_CONTRACT_URL',
  'PM_WORKSPACE_URL',
  'RESERVATION_URL',
  'BIGAPP_MARKETPLACE_URL',
  'BIGAPP_POLLS_URL',
  'GRADUSNIK_URL',
  'NPS_LIVING_URL',
  'BIGAPP_NEWS_URL',
] as const;

// Необязательные: пустое значение выключает свою функцию, а не весь фронт.
export const OPTIONAL_ENV_KEYS = ['PULSE_API_KEY'] as const;

export type EnvKey = (typeof ENV_KEYS)[number];
export type OptionalEnvKey = (typeof OPTIONAL_ENV_KEYS)[number];
export type Env = Record<EnvKey, string> & Partial<Record<OptionalEnvKey, string>>;

declare global {
  // eslint-disable-next-line no-var
  var __ENV__: Partial<Env> | undefined;
}

// Модуль читается до рендера React, поэтому текст ошибки пишется прямо в #root.
const fail = (message: string): never => {
  const root = document.getElementById('root');
  if (root) root.textContent = message;
  throw new Error(message);
};

const readEnv = (): Env => {
  const raw = globalThis.__ENV__;
  if (!raw) return fail('Не загружен /env.js: переменные окружения фронта недоступны');

  const missing = ENV_KEYS.filter((key) => !raw[key]);
  if (missing.length) return fail(`В /env.js не заданы: ${missing.join(', ')}`);

  return raw as Env;
};

export const env = readEnv();

export const isProduction = env.APP_ENV === 'production';
export const isStage = env.APP_ENV === 'stage';
export const isTest = env.APP_ENV === 'development';
